/* eslint-disable */
import { useState, useEffect } from 'react';
import { getBankAccounts } from 'api';
import type { IBankAccount } from 'interfaces';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from 'store/hooks';
import { updateUserAction } from 'store/slices/user';

export const useFetchBankAccount = (forceUpdate?: any, skipCall = false, separatedResponses = false) => {
  const [bankAccounts, setBankAccounts] = useState<IBankAccount[]>([]);
  const [wallets, setWallets] = useState<IBankAccount[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const { state } = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    let stillMounted = true;

    const getData = async () => {
      if (skipCall || state?.partialView) {
        setIsLoading(false);
        return;
      }
      setIsLoading(true);
      try {
        const data: IBankAccount[] = await getBankAccounts();
        const sortedAccounts = data.filter(account => !!account.number).sort((a, b) => +b.is_default - +a.is_default);
        if (separatedResponses) {
          const bankAccountsOnly = sortedAccounts?.filter(account => account.type === 'bank_account');
          const walletsOnly = sortedAccounts?.filter(account => account.type === 'wallet_account');
          setBankAccounts(bankAccountsOnly);
          setWallets(walletsOnly);
        } else {
          setBankAccounts(sortedAccounts);
        }

        if (data?.length) {
          const defaultAccount = data?.filter(payout => payout.is_default)[0];
          dispatch(
            updateUserAction({
              user: {
                payout_account: {
                  uuid: defaultAccount?.uuid,
                  type: defaultAccount?.type,
                  ...(defaultAccount?.number && { number: defaultAccount?.number }),
                },
              },
            }),
          );
        }
      } catch (error) {
        setBankAccounts([]);
        throw error;
      } finally {
        setIsLoading(false);
      }
    };

    if (stillMounted) {
      getData();
    }

    return () => {
      stillMounted = false;
    };
  }, [forceUpdate, skipCall]);

  return { bankAccounts, wallets, isLoading };
};
